import { c as _c } from "react/compiler-runtime";
import ErrorFallback from '@/app/error-boundary/ui/ErrorFallback';
import { DEFAULT_LANGUAGE } from '@/shared/localization';
import { koCommonMessages as commonMessages, koErrorMessages as errorMessages } from '@/shared/localization';
import { NextIntlClientProvider } from 'next-intl';
import { ErrorBoundaryProps } from '../model/types';

// global-error 는 루트 레이아웃(=[locale] Provider) 바깥에서 렌더되므로
// useTranslations 가 동작하도록 Provider 를 직접 씌운다. ErrorFallback 은 error,
// 그 안의 ErrorPage 는 common(actions.goHome) 네임스페이스를 쓰므로 둘 다 주입한다.
// 이 경로에선 로케일 컨텍스트가 없어 운영 기본 언어(ko) 메시지를 사용한다.
export default function GlobalErrorBoundary(t0) {
  const $ = _c(4);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      error: errorMessages,
      common: commonMessages
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== error || $[2] !== reset) {
    t2 = <html><body><NextIntlClientProvider locale={DEFAULT_LANGUAGE} messages={t1}><ErrorFallback error={error} reset={reset} /></NextIntlClientProvider></body></html>;
    $[1] = error;
    $[2] = reset;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}